import { cn } from '@quickmd-llc/design-system';
import FilteredProvider from './FilteredProvider';
import ProviderSearch from './ProviderSearch';
import TimeOfDayButtonGroup from './TimeOfDayButtonGroup';
import { useFilters } from './useFilters';

export default function Filters() {
  const { provider, showFilters } = useFilters();

  const showProvider = Boolean(provider);
  const showProviderSearch = Boolean(!provider);

  return (
    <div className="grid gap-2">
      <div className={cn('grid gap-2', showFilters ? 'visible' : 'hidden')}>
        <TimeOfDayButtonGroup />

        {showProviderSearch && <ProviderSearch />}
      </div>

      {showProvider && <FilteredProvider />}
    </div>
  );
}

export { default as FiltersButton } from './FiltersButton';
